import React, { useState } from "react";


const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    /*emailjs
      .send(
        "service_qekjgys",       // ✅ Service ID
        "template_gou1bjb",      // ✅ Template ID
        {
          fullName: formData.fullName,
          contactNo: formData.contactNo,
          email: formData.email,
          address: formData.address,
          message: formData.message,
        },
        "Ih22Y6FJWnt1u1EJx"       // ✅ Public Key
      )
      .then(
        () => {
          alert("✅ तुमचा संदेश यशस्वीरित्या पाठवला गेला आहे!");
          setFormData({
            fullName: "",
            contactNo: "",
            email: "",
            address: "",
            message: "",
          });
        },
        (error) => {
          console.error(error);
          alert("❌ संदेश पाठवताना अडचण आली. कृपया पुन्हा प्रयत्न करा.");
        }
      );*/
  };

  /* ================= Contact Info Cards ================= */
  const sectionStyles = {
    container: {
      maxWidth: "1100px",
      margin: "50px auto",
      padding: "10px",
    },
    title: {
      textAlign: "center",
      marginBottom: "30px",
      color: "#b91c1c",
      fontSize: "32px",
      fontWeight: "700",
    },
    row: {
      display: "flex",
      justifyContent: "center",
      gap: "25px",
      flexWrap: "wrap",
    },
    card: {
      padding: "25px",
      borderRadius: "12px",
      textAlign: "center",
      width: "300px",
      boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
      color: "white",
      fontSize: "18px",
      fontWeight: "500",
    },
  };

  const ContactSection = () => (
    <div style={sectionStyles.container}>
      <h2 style={sectionStyles.title}>संपर्क माहिती</h2>

      <div style={sectionStyles.row}>
        <div style={{ ...sectionStyles.card, backgroundColor: "#0d6efd" }}>
          <h3>📍 पत्ता</h3>
          <p>
            ग्रामपंचायत ठोंबरा <br />
            पं. स. उमरेड, जि. नागपूर <br />
            महाराष्ट्र – 441203
          </p>
        </div>

        <div style={{ ...sectionStyles.card, backgroundColor: "#198754" }}>
          <h3>📞 फोन</h3>
          <p>8180829537 | 9834506167</p>
          <p>सकाळी ९:०० ते दुपारी ५:००</p>
        </div>

        <div
          style={{
            ...sectionStyles.card,
            backgroundColor: "#ffc107",
            color: "#000",
          }}
        >
          <h3>✉ ई-मेल</h3>
          <p>thombragp4@gmail.com</p>
        </div>
      </div>
    </div>
  );

  /* ================= Main Styles ================= */
  const styles = {
    main: {
      fontFamily: "Poppins, sans-serif",
      background: "linear-gradient(135deg, #e8f5e9, #ffffff)",
    },
    container: {
      maxWidth: "800px",
      margin: "30px auto",
      backgroundColor: "#fff",
      padding: "40px",
      borderRadius: "20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      borderTop: "6px solid #16a34a",
    },
    heading: {
      fontSize: "30px",
      color: "#14532d",
      fontWeight: "700",
      textAlign: "center",
    },
    subheading: {
      textAlign: "center",
      color: "#666",
      marginBottom: "25px",
    },
    label: { fontWeight: "600" },
    input: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      marginBottom: "18px",
    },
    textarea: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      marginBottom: "18px",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#16a34a",
      border: "none",
      borderRadius: "8px",
      color: "#fff",
      fontWeight: "700",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.main}>
      <ContactSection />

      <div style={styles.container}>
        <h1 style={styles.heading}>📞 संपर्क करा</h1>
        <p style={styles.subheading}>
          तुमचे प्रश्न, सूचना आणि अभिप्राय आमच्यासाठी महत्त्वाचे आहेत.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>पूर्ण नाव</label>
          <input name="fullName" value={formData.fullName} onChange={handleChange} required style={styles.input} />

          <label style={styles.label}>संपर्क क्रमांक</label>
          <input name="contactNo" value={formData.contactNo} onChange={handleChange} required style={styles.input} />

          <label style={styles.label}>ई-मेल</label>
          <input name="email" value={formData.email} onChange={handleChange} required style={styles.input} />

          <label style={styles.label}>पत्ता</label>
          <textarea name="address" value={formData.address} onChange={handleChange} style={styles.textarea} />

          <label style={styles.label}>संदेश</label>
          <textarea name="message" value={formData.message} onChange={handleChange} style={styles.textarea} />

          <button type="submit" style={styles.button}>✉️ संदेश पाठवा</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
